import { render, staticRenderFns } from "./buyCarMini.vue?vue&type=template&id=5d89148e&scoped=true&"
import script from "./buyCarMini.vue?vue&type=script&lang=js&"
export * from "./buyCarMini.vue?vue&type=script&lang=js&"
import style0 from "./buyCarMini.vue?vue&type=style&index=0&id=5d89148e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89148e",
  null
  
)

component.options.__file = "buyCarMini.vue"
export default component.exports